// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.documenttype.knowntypes

import org.multipaz.cbor.DataItem
import org.multipaz.documenttype.knowntypes.PaymentTransaction.Recurrence
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.toDataItemFullDate
import org.multipaz.cbor.toDataItem
import org.multipaz.documenttype.knowntypes.PaymentTransaction.Frequency

fun Recurrence.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "ZIXg2mSl3gdQ60lf41EXfr-bwUYw0HPFt-Ld61D16-c")
val Recurrence_cborSchemaId = ByteString(100, -123, -32, -38, 100, -91, -34, 7, 80, -21, 73, 95, -29, 81, 23, 126, -65, -101, -63, 70, 48, -48, 115, -59, -73, -30, -35, -21, 80, -11, -21, -25)

fun Recurrence.Companion.fromCbor(data: ByteArray): Recurrence {
    return Recurrence.fromDataItem(Cbor.decode(data))
}

val Recurrence.Companion.cborSchemaId: ByteString
    get() = Recurrence_cborSchemaId

fun Recurrence.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("frequency", Tstr(this.frequency.name))
    val startDate = this.startDate
    if (startDate != null) {
        builder.put("startDate", startDate.toDataItemFullDate())
    }
    val endDate = this.endDate
    if (endDate != null) {
        builder.put("endDate", endDate.toDataItemFullDate())
    }
    val number = this.number
    if (number != null) {
        builder.put("number", number.toDataItem())
    }
    return builder.end().build()
}

fun Recurrence.Companion.fromDataItem(dataItem: DataItem): Recurrence {
    val frequency = Frequency.valueOf(dataItem["frequency"].asTstr)
    val startDate0 = if (dataItem.hasKey("startDate")) {
        dataItem["startDate"].asDateString
    } else {
        null
    }
    val endDate0 = if (dataItem.hasKey("endDate")) {
        dataItem["endDate"].asDateString
    } else {
        null
    }
    val number0 = if (dataItem.hasKey("number")) {
        dataItem["number"].asNumber
    } else {
        null
    }
    return Recurrence(
        frequency = frequency,
        startDate = startDate0,
        endDate = endDate0,
        number = number0,
    )
}
